// @ts-check
/** @jsxRuntime classic */
/** @jsx jsx */
import ProducerPreviewPage from '@bottlebooks/gatsby-theme-event/src/components/Preview/ProducerPreviewPage';
import { jsx } from 'theme-ui';
import PreviewLinkProvider from '../../../../../PreviewLinkProvider';

/**
 * This page is only here to get the named joinCode parameter out of the URL.
 * The <ProtectedRoute> wrapper picks it up and passes it to the Join component.
 * Once we get here, we have already joined the event successfully,
 * so we can redirect to the landing page.
 * @returns
 */
export default function ProducerPreview(props) {
  const { collectionId, producerId } = props.params;
  return (
    <PreviewLinkProvider collectionId={collectionId} locale="en">
      <ProducerPreviewPage
        collectionId={collectionId}
        locale="en"
        producerId={producerId}
      />
    </PreviewLinkProvider>
  );
}
